export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/48c3d350a874654b9919fc00f7ab5f35.png";